export default __webpack_public_path__ + "static/media/Rectangle 27.a0f2fc96.png";